import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailLetter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 -0.028)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M0,.028H24v24H0v-24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M3,9.7V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V9.7"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M9.12,14.88,3.59,20.41"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M20.41,20.41l-5.53-5.53"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M6,6.622,3.886,8.044a2,2,0,0,0,0,3.319L9.76,15.315a4.01,4.01,0,0,0,4.478,0l5.874-3.952a2,2,0,0,0,0-3.319L18,6.622"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M18,12.785V3.9a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1v8.883"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M9,6.5h6"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M9,10h6"
			})
		]
	})]
});
export default SvgMailLetter;
